import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function notificationReducer(state = initialState.notifications, action) {
  switch (action.type) {
    case types.ADD_NOTIFICATION_SUCCESS:
      return action.notificationObject;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/notificationReducer.js